export const BASE_CLASS = 'mt-NetDrawer'

/**
 * Step definitions for Net Drawer
 */
export const STEPS = {
  CHAT: 'chat',
  FEEDBACK: 'assistant-feedback',
  CHAT_HISTORY: 'chat-history',
  CONTACT_FORM: 'contact-form'
}

/**
 * Step configuration
 * Defines header behavior for each step
 */
export const getStepsConfig = i18n => ({
  [STEPS.CHAT]: {
    showLogo: true,
    showBackButton: false,
    showHistoryButton: true,
    showExpandButton: true
  },
  [STEPS.FEEDBACK]: {
    title: i18n.t('NET.FEEDBACK.HEADER_TITLE'),
    showLogo: false,
    showBackButton: true,
    showHistoryButton: false,
    showExpandButton: false
  },
  [STEPS.CHAT_HISTORY]: {
    title: i18n.t('NET.CHAT_HISTORY.HEADER_TITLE'),
    showLogo: false,
    showBackButton: true,
    showHistoryButton: false,
    showExpandButton: false
  },
  [STEPS.CONTACT_FORM]: {
    title: i18n.t('COMMON_CONTACT'),
    showLogo: false,
    showBackButton: true,
    showHistoryButton: false,
    showExpandButton: false
  }
})

export const MESSAGE_ROLES = {
  ASSISTANT: 'assistant',
  USER: 'user'
}

export const BLOCK_TYPES = {
  TEXT: 'text',
  RESULTS: 'search_results',
  END: 'end_chat',
  AD_CARD: 'ad_card'
}
